import React, {
    useContext, useCallback, useState, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import {
    WizardPage,
    wizardProps,
    WizardPageTemplate,
    WizardPageTemplateWithTitle
} from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
// import { appendMetadataWithIndex, readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import metadata from './TypeOfIncidentPage.metadata.json5';
//import FNOLCriminalDamagePage from '../CriminalDamage/CriminalDamagePage';
//import FNOLFireDamagePage from '../FireDamage/FireDamagePage';
//import FNOLWaterDamagePage from '../WaterDamage/WaterDamagePage';
import messages from '../../FNOLNonAuto.messages';
//import FNOLOtherDamagePage from "../OtherDamage/OtherDamagePage";
import FNOLIncidentCommonDetailsPage from "gw-capability-fnol-common-react/pages/CommonDetails/CommonDetails";

function getLossCategory(claimVM) {
    const lossCause = _.get(claimVM, 'lossCause.value.code');
    switch (lossCause) {
        case 'fire':
            return 'fire';
        case 'water':
        case 'mold':
            return 'water';
        case 'burglary':
        case 'vandalism':
        case 'riotandcivil':
        case 'theftvandalism':
            return 'theftvandalism';
        default:
            return 'othercauses';
    }
}

/*const criminalDamage = {
    id: 'details',
    path: '/details',
    component: FNOLCriminalDamagePage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: messages.hoDetails
};

const waterDamage = {
    id: 'details',
    path: '/details',
    component: FNOLWaterDamagePage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: messages.hoDetails
};

const fireDamage = {
    id: 'details',
    path: '/details',
    component: FNOLFireDamagePage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: messages.hoDetails
};

const otherDamage = {
    id: 'details',
    path: '/details',
    component: FNOLOtherDamagePage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: messages.hoDetails
}
const otherDamage = {
    id: 'details',
    path: '/details',
    component: FNOLNonAutoIncidentDetailsPage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: messages.hoDetails
}; */

const otherDamage = {
    id: 'details',
    path: '/details',
    component: FNOLIncidentCommonDetailsPage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    icon: "fas fa-list",
    title: messages.hoDetails
};

function FNOLNonAutoTypeOfIncidentPage(props) {
    const {
        wizardData,
        wizardSnapshot,
        updateWizardData,
        history,
        steps,
        changeNextSteps,
        authHeader,
        history: {
            location: { state = {} }
        }
    } = props;
    const { FNOLService } = useDependencies('FNOLService');
    const [isLoading, setIsLoading] = useState(false);
    const [pageData] = useState(state);
    const translator = useContext(TranslatorContext);
    const claimVM = !_.isEmpty(wizardData) ? wizardData : wizardSnapshot;
    // const lossCauseTypesArray = claimVM.lossCause.value.typelist.codes;
    const { onValidate, initialValidation, registerInitialComponentValidation } = useValidation(
        'FNOLNonAutoTypeOfIncidentPage'
    );
    const includeLossCodes = [
        'fire', 'water', 'wind', 'theftvandalism', 'livestock', 'machineryequipment', 'othercauses'
    ];

    const getCustomOrdering = (code) => {
        switch (code) {
            case 'fire':
                return 1;
            case 'water':
                return 2;
            case 'wind':
                return 3;
            case 'theftvandalism':
                return 4;
            case 'livestock':
                return 5;
            case 'machineryequipment':
                return 6;
            case 'othercauses':
                return 7;
            default:
                return 8;
        }
    }

    const getLossCuaseValues = useMemo(() => {
        const policyType = _.get(claimVM, 'policy.policyType.value');
        if (policyType === 'Businessowners' || policyType === 'BP7Businessowners' || policyType === 'BP7BusinessOwners') {
            return claimVM.boOrFarmLossCause.aspects.availableValues;
        }
        return claimVM.lossCause.aspects.availableValues;
    }, []);

    const filterItems = _.filter(getLossCuaseValues, (typeCode) => {
        return includeLossCodes.indexOf(typeCode.code) !== -1;
    }).map((typeCode) => {
        return {
            code: typeCode.code,
            name: translator({
                id: typeCode.name,
                defaultMessage: typeCode.name
            }),
            priority: getCustomOrdering(typeCode.code)
        };
    });
    const filteredLossCuases = _.orderBy(filterItems, 'priority');

    const incidentPageHandling = useCallback(() => {
        const detailsPageIndex = 2;
        const changeArrayIndex = 0;
        const remainingSteps = steps.slice(detailsPageIndex, steps.length);
        switch (getLossCategory(claimVM)) {
            case 'fire':
                /*remainingSteps[changeArrayIndex] = fireDamage;
                break;*/
            case 'water':
            case 'mold':
                /*remainingSteps[changeArrayIndex] = waterDamage;
                break;*/
            case 'burglary':
            case 'vandalism':
            case 'riotandcivil':
            case 'theftvandalism':
                /*remainingSteps[changeArrayIndex] = criminalDamage;*/
                remainingSteps[changeArrayIndex] = otherDamage;
                break;
            default:
                remainingSteps[changeArrayIndex] = otherDamage;
        }
        changeNextSteps(remainingSteps);
        return claimVM;
    }, [changeNextSteps, claimVM, steps]);

    useEffect(() => {
        incidentPageHandling();
        const policyType = _.get(claimVM, 'policy.policyType.value');
        if (policyType === 'Businessowners' || policyType === 'BusinessOwners') {
            _.set(claimVM, 'lobs.businessOwners.dateOfNotice', claimVM.lossDate.value);
            _.set(claimVM, 'boOrFarmLossCauseType', claimVM.boOrFarmLossCauseType.aspects.availableValues[0].code);
        } else if (policyType === 'BP7Businessowners' || policyType === 'BP7BusinessOwners') {
            _.set(claimVM, 'lobs.farm.dateOfNotice', claimVM.lossDate.value);
            _.set(claimVM, 'boOrFarmLossCauseType', claimVM.boOrFarmLossCauseType.aspects.availableValues[0].code);
        } else {
            _.set(claimVM, 'lossCauseType', claimVM.lossCauseType.aspects.availableValues[0].code);
        }

        // only execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /* const getLossCause = useCallback(
        (selectedLossCause) => {
            const LossCause = _.find(lossCauseTypesArray, (cause) => {
                return cause.code === selectedLossCause;
            });
            _.set(claimVM, 'lossCause.value', LossCause);
            updateWizardData(claimVM);
        },
        [claimVM, lossCauseTypesArray, updateWizardData]
    ); */

    const onNext = useCallback(() => {
        const policyType = _.get(claimVM, 'policy.policyType.value');
        let miscellaneous;
        if (policyType === 'Businessowners' || policyType === 'BP7Businessowners' || policyType === 'BP7BusinessOwners'){
            miscellaneous = claimVM.boOrFarmLossCause.value.code === 'miscellaneous';
        } else {
            miscellaneous = claimVM.lossCause.value.code === 'miscellaneous';
        }
        const { redirectPath } = pageData;
        if (miscellaneous) {
            return history.push({
                pathname: '/contact-agent',
                state: {
                    redirectPath: redirectPath
                }
            });
        }
        const policyNumber = _.get(claimVM, 'policy.policyNumber.value');
        const isClaimNumberAvailable = _.get(claimVM, 'claimNumber.value');
        if (isClaimNumberAvailable) {
            return incidentPageHandling();
        }
        setIsLoading(true);
        return FNOLService.getFNOLDetails(policyNumber, claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = response;
                return incidentPageHandling();
            })
            .catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.otherCreateDraftErrorTitle,
                    message: messages.otherCreateDraftErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, authHeader, claimVM, history, incidentPageHandling, pageData]);

    const isClaimStatus = useCallback(() => {
        const { claimStatus } = pageData;
        return !_.isEmpty(claimStatus);
    }, [pageData]);

    const getLossCause = useCallback(() => {
        const policyType = _.get(claimVM, 'policy.policyType.value');
        if (policyType === 'Businessowners' || policyType === 'BP7Businessowners' || policyType === 'BP7BusinessOwners') {
            return _.get(claimVM, 'boOrFarmLossCause.value.code');
        }
        return _.get(claimVM, 'lossCause.value.code');
    }, [claimVM]);

    const setLossCauseType = useCallback((lossCause) => {
        const policyType = _.get(claimVM, 'policy.policyType.value');
        if (policyType === 'Businessowners' || policyType === 'BP7Businessowners' || policyType === 'BP7BusinessOwners') {
            _.set(claimVM, 'boOrFarmLossCause.value', lossCause);
            _.set(claimVM, 'boOrFarmLossCauseType', claimVM.boOrFarmLossCauseType.aspects.availableValues[0].code);
        } else {
            _.set(claimVM, 'lossCause.value', lossCause);
            _.set(claimVM, 'lossCauseType', claimVM.lossCauseType.aspects.availableValues[0].code);
        }
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    useEffect(() => {
        registerInitialComponentValidation(isClaimStatus);
    }, [registerInitialComponentValidation, isClaimStatus]);

    const overrideProps = {
        lossCauseRadioButton: {
            value: getLossCategory(claimVM)
        },
        typeOfIncidentPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.hoCreateDraftClaim)
        },
        claimsHoContainerPage: {
            visible: !isLoading
        },
        incidentType: {
            availableValues: filteredLossCuases,
            onValueChange: (value) => {
                setLossCauseType(value);
            },
            value: getLossCause()
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM, overrideProps]
    );

    const resolvers = {
        resolveValue: readValue,
        resolveCallbackMap: {
            getLossCause
        }
    };

    return (
        <WizardPage onNext={onNext} skipWhen={initialValidation} template={WizardPageTemplate}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                resolveValue={resolvers.resolveValue}
            />
        </WizardPage>
    );
}

FNOLNonAutoTypeOfIncidentPage.propTypes = wizardProps;
FNOLNonAutoTypeOfIncidentPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

export default withRouter(withAuthenticationContext(FNOLNonAutoTypeOfIncidentPage));
